export const formatPhone = (value) => {
    // 숫자만 추출
    const digits = value.replace(/\D/g, "").slice(0, 11);   // 11자리까지 제한

    // 010-xxxx-xxxx 또는 010-xxx-xxxx
    if (digits.length < 4) return digits;                                    // 0~3
    if (digits.length < 8)
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;                     // 4~7
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`; // 8~11
};